module.exports = __webpack_public_path__ + "media/images/sindma/SINDMA_web-44929d6ec6ffe4a193d039158c970275.png";